export default "__VITE_ASSET__4Nvy6SwS__"